import { FileUpIcon } from 'components/Icons';

import { ProjectFilesModal } from './ProjectFilesModal';

import { registerProjectOption } from '../options';
import { isOwner } from 'entities';

export default registerProjectOption({
  Icon: FileUpIcon,

  getLabel: (t) => t('files'),

  modal: 'FILES',
  overlay: ProjectFilesModal,

  shortcut: {
    key: 'G',
    triggerKey: ['ctrl'],
  },

  useOption: ({ openModal, project, loggedUser }) => {
    const isEnabled = !!project.files?.length || isOwner(project, loggedUser);

    return {
      action: () => openModal('FILES'),
      isEnabled,
    };
  },
});
